export default __webpack_public_path__ + "static/media/expOrange.c3e97320.svg";